exports = module.exports = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\cssToString.js")();
exports.push([module.id, ".rule-import2 {\r\n\tbackground: red !important;\r\n}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/css-loader!./loaders/_css/folder/stylesheet-import3.css
 ** module id = 5
 ** module chunks = 0
 **/